import ShellHeader from '../components/ShellHeader';
import Testimonials from '../components/Testimonials';
import TestimonialForm from '../components/TestimonialForm';

function ContactPage({ authUser }) {
  return (
    <div className="site-shell">
      <ShellHeader authUser={authUser} />

      <main className="content-wrap about-content-wrap contact-content-wrap">
        <div className="contact-left-column">
          <section className="content-page-block about-page-main contact-page-main">
            <div className="section-header">
              <h2>Contact M.J. Motors</h2>
            </div>

            <p>
              Looking for quality used cars and vans in Tunstall? M.J. Motors is here to help with
              friendly advice, flexible finance options, and straightforward support from first enquiry
              to handover.
            </p>

            <p>
              Speak with our team about current stock, part exchange, or your next vehicle search.
              We are a trusted local motor dealer serving Stoke-on-Trent and surrounding areas.
            </p>

            <p>
              You can call us or email us directly and one of our team members will get back to you
              as quickly as possible.
            </p>
          </section>

          <Testimonials limit={50} pageSize={10} />
        </div>

        <aside className="about-page-sidebar" aria-label="Contact details">
          <section className="content-page-block about-side-panel">
            <h3 className="about-side-title">Contact Us</h3>
            <a className="about-contact-link" href="tel:01782835561">01782 835561</a>
            <a className="about-contact-link" href="mailto:markjeffery1000@yahoo.co.uk">
              Email Us
            </a>
          </section>

          <section className="content-page-block about-side-panel">
            <h3 className="about-side-title">Visit Us</h3>
            <p className="about-contact-text">
              M.J. Motors
              <br />
              Summerbank Service Station
              <br />
              High Street
              <br />
              Stoke-on-Trent
              <br />
              Staffordshire
              <br />
              ST6 5ET
            </p>
          </section>

          <TestimonialForm />
        </aside>
      </main>
    </div>
  );
}

export default ContactPage;
